import {Layout} from "antd";
import Header from "../components/headerComponent/header";
import Footer from "../components/footerComponent/footer";
import React from "react";
import AddBonusRule from "../components/financeComponent/addBonusRuleComponent";

export default function AddBonusRulePage() {
    return (
        <Layout>
            <Header/>
            <AddBonusRule/>
            <Footer/>
        </Layout>
    );
}